import { z } from 'zod';
import { PAGINATION_SORT_DIRECTION } from '~/constants';

import {
  ValidUuidOrNotSetSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodFtpPollersSearchParamsSchema = z
  .object({
    buyerCompanyAccountId: ValidUuidOrNotSetSchema,
    buyerId: ValidUuidOrNotSetSchema,
    isActive: z.boolean().nullish(),
    issuerCompanyAccountId: ValidUuidOrNotSetSchema,
    issuerId: ValidUuidOrNotSetSchema,
    page: z.number().nonnegative().prefault(0),
    pollingProblem: z.boolean().nullish(),
    searchString: z.string().trim().prefault(''),
    sortBy: z.string().optional().prefault('last_run'),
    sortDirection: z
      .enum(PAGINATION_SORT_DIRECTION)
      .optional()
      .prefault('DESC'),
  })
  .transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
  );

export type ftpPollerSearchParams = z.infer<
  typeof zodFtpPollersSearchParamsSchema
>;
